/* eslint-disable @typescript-eslint/no-shadow */
import MapView from '@arcgis/core/views/MapView';
import GraphicsLayer from '@arcgis/core/layers/GraphicsLayer';
import { MapPlugin } from '../arcgis-types';
import { buildGraphic, removeTextLabelGraphics } from '../../../sketch-editor/graphics-handler';
import { PARENT_COLOR } from '../../../sketch-editor/colorizer';
import { GraphicStyle } from '../../../sketch-editor/graphic-styles';
import RepeatableGraphicsTracker, { RepeatableGraphicsTrackerData } from '../utils/repeatable-graphics-tracker';
import { DataViewSourceRecord } from '../../../sketch-editor/data-fetcher';

export const REPEATABLE_LAYER_ID = 'repeatables-repeatable-layer';
export const PARENT_LAYER_ID = 'repeatables-parent-layer';
let repeatableGraphicsHandler: RepeatableGraphicsTrackerData | undefined;

/**
 * Repeatable pluggin manages repeatable feature graphics on ArcGIS MapView
 * It is responsible for inserting and updating parent and child repeatables
 * on the mapView instance.
 */
const Repeatables: (
  repeatablesWithParent: DataViewSourceRecord[],
  color: string,
) => MapPlugin = (repeatablesWithParent, color) => {
  repeatableGraphicsHandler = repeatableGraphicsHandler ?? RepeatableGraphicsTracker(repeatablesWithParent);

  const redrawRepeatables = (view: MapView, repeatableFeatures) => {
    const repeatableLayer = view.map.findLayerById(REPEATABLE_LAYER_ID) as GraphicsLayer;
    const parentLayer = view.map.findLayerById(PARENT_LAYER_ID) as GraphicsLayer;

    if (!repeatableLayer || !parentLayer) {
      console.error("Couldn't find my layers - maybe this is an error?!?!");
      return;
    }

    repeatableLayer.removeAll();
    removeTextLabelGraphics(view);

    const updatedGraphics = repeatableFeatures
      .filter((repeatable) => Boolean(!repeatable?.data?.parent))
      .filter((repeatable) => Boolean(repeatable?.geometry?.type))
      .map((repeatable) => buildGraphic(repeatable.geometry, color));

    const repeatableGraphics = [...updatedGraphics];
    repeatableLayer.addMany(repeatableGraphics);
  };

  return ({
    extendMap: (view: MapView) => {
      const parentLayer = new GraphicsLayer({ id: PARENT_LAYER_ID });
      const parent = repeatablesWithParent
        .filter((repeatable) => Boolean(repeatable?.data?.parent))[0];

      view.map.add(parentLayer);

      view.map.add(new GraphicsLayer({ id: REPEATABLE_LAYER_ID }));

      if (parent?.geometry?.type) {
        parentLayer.add(buildGraphic(parent.geometry, PARENT_COLOR, GraphicStyle.PARENT_GEOMETRY));
      }

      redrawRepeatables(view, repeatablesWithParent);
    },
    onChange: (view: MapView) => {
      if (repeatableGraphicsHandler?.hasChanges(repeatablesWithParent)) {
        redrawRepeatables(view, repeatablesWithParent);
      }
    },
  });
};
export default Repeatables;
